import { Redirect } from "expo-router";

import { useAuthState } from "@/auth/AuthProvider";

export default function IndexRoute() {
  const { signedIn, loading } = useAuthState();

  if (loading) {
    return null;
  }

  return <Redirect href={signedIn ? "/recitals" : "/login"} />;
}
